import {
  SET_TURNOS_RECEPCIONADOS,
  SET_TURNOS_RECEPCIONADOS_ALL,
} from "../ActionTypes";
import turnosSeleccionadosInitialState from "../initialState/turnosSeleccionadosInitialState";

const turnosRecepcionados = (state, { payload, type }) => {
  switch (type) {
    case SET_TURNOS_RECEPCIONADOS: {
      // Normalizamos para que `data` sea SIEMPRE un array.
      // - Si llega un array (ej. desde Home.js con la lista filtrada por presente),
      //   se reemplaza el contenido.
      // - Si llega un objeto (ej. desde TurnoProximo después de cada presente
      //   exitoso), se agrega al array existente evitando duplicados por idturno.
      // Antes el reducer reemplazaba siempre `data: payload`, lo que rompía la
      // pantalla TurnosRecepcionadosQR cuando se pasaba un turno individual
      // porque `listaTurnos.map(...)` esperaba un array.
      const previo = Array.isArray(state.turnosRecepcionados?.data)
        ? state.turnosRecepcionados.data
        : [];

      let nuevoData;
      if (Array.isArray(payload)) {
        nuevoData = payload;
      } else if (payload && typeof payload === "object") {
        const yaEsta = previo.some(
          (t) => t?.idturno != null && t.idturno === payload.idturno,
        );
        nuevoData = yaEsta ? previo : [...previo, payload];
      } else {
        nuevoData = previo;
      }

      return {
        ...state,
        turnosRecepcionados: {
          ...state.turnosRecepcionados,
          loading: false,
          error: false,
          data: nuevoData,
        },
      };
    }
    case SET_TURNOS_RECEPCIONADOS_ALL:
      return {
        ...state,
        turnosRecepcionados: {
          ...state.turnosRecepcionados,
          loading: false,
          error: false,
          data: Array.isArray(payload) ? payload : [],
        },
      };

    default:
      return turnosSeleccionadosInitialState;
  }
};

export default turnosRecepcionados;
